import React from 'react'
import { FeedItem } from '../../../../../Api'
import { colors } from '../../../../../Components/consts'
import { Play } from '../../../../../Components/Icons'
import { convertHourMinSec } from '../../../../../Utils/formatting/formatting'
import { AdditionalVidCon, VideoLink, VideoThumbSmall } from '../styles'
import { BlurredBackground } from '../../../../../Components/Feed/Videos/styles'

type VideoParams = {
  video: FeedItem
  videoIdx: number
  tag: string | null
  onSelect: (mediaId: string) => void
}

export const AdditionalVideo: React.FC<VideoParams> = ({ video, tag }) => {
  const getVideoDuration = () => {
    if (!video?.duration) return ''

    return convertHourMinSec(video.duration)
  }

  const getUrl = () => {
    return tag
      ? `${window.location.origin}/videos/tag/${tag}?mediaId=${video.mediaId}`
      : `${window.location.origin}/videos/${video.mediaId}`
  }
  return (
    <VideoLink href={getUrl()} aria-label="Video">
      <AdditionalVidCon>
        {video.previewImage ? (
          <VideoThumbSmall backgroundImg={video.previewImage}>
            <BlurredBackground backgroundImg={video.previewImage} />
            <div className="imgCon">
              <img src={video.previewImage} alt={video.title || ''} />
            </div>
            <Play className="playBtn" width={25} height={25} fill={colors.white} />
          </VideoThumbSmall>
        ) : (
          <span></span>
        )}
        <div className="infoCon">
          <div className="title">{video.title}</div>
          <div className="durationCon">
            <div className="durationText">{getVideoDuration()}</div>
          </div>
        </div>
      </AdditionalVidCon>
    </VideoLink>
  )
}
